// extracted by mini-css-extract-plugin
export default {"dark_button":"DarkButton_dark_button__lCB20","button_text":"DarkButton_button_text__xORK3","button_icon":"DarkButton_button_icon__l0ea2"};